<template>
  <div>
    <vxe-toolbar size="mini" v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          v-if="invoiceInfo.invoiceType != 'invoice'"
          @click="handleInsert"
          type="primary"
          size="medium"
          class="vxe-btn-primary"
          ><svg-icon
            class="icon-img"
            style="font-size: 16px; padding-right: 6px"
            icon-class="icon-add"
          />{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          type="primary"
          size="medium"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          :disabled="isDisabledRowDeleteBtn"
          @click="handleDelete"
          >{{ $t('xTable.delete') }}</vxe-button
        >
        <vxe-button
          v-if="invoiceInfo.invoiceType == 'invoice'"
          @click="handleSettleBatch()"
          type="primary"
          size="medium"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >关联应收结算单</vxe-button
        >
        <vxe-button
          v-if="['物贸', '多式联运', '城矿'].includes(userInfo.businessGroup)"
          @click="importRowDetail()"
          type="primary"
          size="medium"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >导入</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :max-height="$store.state.app.tableHeight"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: this.activeRowMethod }"
      size="mini"
      ref="ruleTable"
      highlight-current-row
      :edit-rules="validRules"
      :columns="columnList"
      :valid-config="{ autoPos: true, message: 'inline' }"
      @edit-closed="editClosedEvent"
      align="center"
      :show-footer="true"
      :footer-method="footerMethodTotal"
      auto-resize
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @cell-click="dblclickEvent"
    >
    </vxe-grid>
    <settlement
      ref="settlementBatch"
      isSaleInvoiceBill
      @updateSettle="updateSettle"
      isManyApi
      v-if="isVisibleSettlement"
    ></settlement>
    <Upload
      ref="siruiUpload"
      :isShowDownTemplateBtn="true"
      @ossSuccess="importSuccess"
      :action="action"
      :data="importData"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';
  import Settlement from '@/components/ReciveSettlement';
  import Upload from '@/pages/property/energyCibsynption/components/importDialog';

  export default {
    props: {
      canEdit: {
        type: Boolean,
        default: false,
      },
      validateInvoice: {
        type: Function,
        default: null,
      },
      invoiceInfo: {
        type: Object,
        default: () => {},
      },
      currencyList: {
        type: Array,
        default: () => [],
      },
      dictMap: {
        type: Object,
        default: () => {},
      },
      currentSettlementBusinessType: {
        type: String,
        default: '',
      },
      isDisabledRowDeleteBtn: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Settlement,
      Upload,
    },
    data() {
      return {
        footerTotalCols: {
          amount: [
            'invoiceAmount',
            'ladingAmount',
            'settlementApplyInvoiceAmount',
            'excludedTaxAmount',
            'taxAmount',
            'invoiceAccountedAmount',
            'excludedTaxAccountedAmount',
            'taxAccountedAmount',
            'ladingDifferenceAmount',
          ],
          quantity: ['ladingQuantity'],
          invoiceQuantity: ['invoiceQuantity'],
        },
        tableData: [],
        invoiceType: '',
        companyCode: '',
        taxRateList: [], //税率列表
        departmentList: [],
        isVisibleSettlement: false,
        expenseItemList: [],
        currentInfo: {}, //当前选中的行
        action: '/financial/financeSalesInvoice/importSettleLine',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      importData() {
        return {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          belongTenantCode: this.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.access_token,
        };
      },
      validRules() {
        // 本次匹配数量 需控制不能大于未开票数量
        // const invoiceQuantityValidate = (rule, value, callback, { row }) => {
        //   if (this.invoiceInfo.invoiceSource == '3') {
        //     callback();
        //   } else {
        //     if (!value || value <= 0) {
        //       callback(new Error('本次匹配数量不能小于0'));
        //     } else {
        //       if (value > row.ladingQuantity - row.invoicedQuantity) {
        //         callback(new Error('本次匹配数量不能大于未开票数量'));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // };

        // 总金额≤提单金额-已开票金额
        // const invoiceAmountValidate = (rule, value, callback, { row }) => {
        //   const invoiceAmount = this.$cal.calCommon(
        //     row.invoiceQuantity,
        //     row.invoiceUnitPrice,
        //     '*',
        //     'amount'
        //   ); //
        //   const checkAmount = this.$cal.calCommon(
        //     row.ladingAmount,
        //     row.invoicedAmount,
        //     '-',
        //     'amount'
        //   ); //
        //   if (invoiceAmount > checkAmount) {
        //     callback();
        //   } else {
        //     callback(new Error(this.$t('saleInvoice.overAmount')));
        //   }
        // };
        const prefixInput = this.$t('addInvoice.invoiceLine.rules.input');
        const prefixSelect = this.$t('addInvoice.invoiceLine.rules.select');
        if (['物贸', '多式联运', '城矿'].includes(this.userInfo.businessGroup)) {
          return {};
        }
        return {
          invoiceDesc: [
            {
              required: true,
              message: prefixInput + this.$t('financeSalesInvoiceDetail.column.invoiceDesc'),
            },
          ],
          invoiceQuantity: [
            {
              required: true,
              message:
                this.invoiceInfo.invoiceType == 'creditMemo'
                  ? '开票数量只能输入负数'
                  : prefixSelect + this.$t('financeSalesInvoiceDetail.column.invoiceQuantity'),
            },
            // { validator: invoiceQuantityValidate}
          ],
          invoiceUnitPrice: [
            {
              required: true,
              message: prefixInput + this.$t('financeSalesInvoiceDetail.column.invoiceUnitPrice'),
            },
          ],
          invoiceAmount: [
            {
              required: true,
              // 区分红票
              message:
                this.invoiceInfo.invoiceType == 'creditMemo'
                  ? '含税总金额只能输入负数'
                  : prefixInput + this.$t('financeSalesInvoiceDetail.column.invoiceAmount'),
              // validator: {invoiceAmountValidate}
            },
          ],
          taxCode: [
            {
              required: true,
              message: prefixSelect + this.$t('financeSalesInvoiceDetail.column.taxCode'),
            },
          ],
          taxRate: [
            {
              required: true,
              message: prefixInput + this.$t('financeSalesInvoiceDetail.column.taxRate'),
            },
          ],
          // excludedTaxAmount: [
          //   {
          //     required: true,
          //     message: prefixInput + this.$t('financeSalesInvoiceDetail.column.excludedTaxAmount'),
          //   },
          // ],
          // taxAmount: [
          //   {
          //     required: true,
          //     message: prefixInput + this.$t('financeSalesInvoiceDetail.column.taxAmount'),
          //   },
          // ],
          excludedTaxAccountedAmount: [
            {
              required: true,
              message:
                prefixInput +
                this.$t('financeSalesInvoiceDetail.column.excludedTaxAccountedAmount'),
            },
          ],
          taxAccountedAmount: [
            {
              required: true,
              message: prefixInput + this.$t('financeSalesInvoiceDetail.column.taxAccountedAmount'),
            },
          ],
          currency: [
            {
              required: true,
              message: prefixInput + this.$t('financeSalesInvoiceDetail.column.currency'),
            },
          ],
          exchangeRate: [
            {
              required: true,
              message: prefixInput + this.$t('financeSalesInvoiceDetail.column.exchangeRate'),
            },
          ],
          productNo: [
            {
              required:
                ['01', '06'].includes(this.invoiceInfo.businessType) &&
                this.invoiceInfo.productType == '1',
              message: '商品编码必填',
            },
          ],
          expenseItem: [
            {
              required: this.invoiceInfo.productType == '3' ? true : false,
              message: '必填字段',
            },
          ],
        };
      },
      maxHeight() {
        return window.innerHeight / 2 + 'px';
      },

      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            title: this.$t('financeSalesInvoiceDetail.column.sortNo'),
            field: 'sortNo',
            type: 'seq',
            width: 60,
          }, //序号
          {
            width: 120,
            field: 'receivableSettlementLineId',
            title: '结算单行号',
          },
          // {
          //   width: 120,
          //   field: 'id',
          //   title: 'id',
          // },
          {
            // 开票描述
            field: 'invoiceDesc',
            title: this.$t('financeSalesInvoiceDetail.column.invoiceDesc'),
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            // 结算单编号
            field: 'receivableSettlementNo',
            title: '结算单编号',
            width: 150,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.receivableSettlementNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="receivableSettlementForLine"
                      isMultiple={true}
                      currentValue={row['receivableSettlementNo']}
                      checkRowKeys={[row['receivableSettlementNo']]}
                      onInput={(val) => this.updateCol(row, val, 'receivableSettlementNo')}
                      extraData={{
                        settlementCompanyNo: this.invoiceInfo.invoiceCompanyCode,
                        settlementDepartmentNo: this.invoiceInfo.invoiceDepartmentNo,
                        canApplyInvoiceFlag: '01',
                      }}
                    ></search-table>,
                  ];
                },
              },
            },
          },
          {
            title: this.$t('financeSalesInvoiceDetail.column.contractNo'),
            field: 'contractNo',
            width: 120,
            editRender:
              this.invoiceInfo.invoiceSource == '3'
                ? { name: 'searchTable', props: { clearable: true } }
                : null,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.contractNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="contractHasDetail"
                    isMultiple={true}
                    currentValue={row['contractNo']}
                    checkRowKeys={[row['contractNo']]}
                    extraData={{
                      groupByContractDetailNoFlag: '1',
                      contractCategory: 'sales',
                      contractCompanyNo: this.invoiceInfo.invoiceCompanyCode,
                      contractBusinessDepartment: this.invoiceInfo.invoiceDepartmentNo,
                      customerNo: this.invoiceInfo.partnerCode,
                      itemType: '0',
                      contractDetailCategory: 'CG04',
                    }}
                    onInput={(val) => this.updateCol(row, val, 'contractNo')}
                  ></search-table>,
                ];
              },
            },
          }, //合同号 手动添加提单号带出
          {
            title: '业务单据号',
            field: 'outboundNo',
            width: 120,
          }, //业务单据号
          {
            title: '商品编码',
            field: 'productNo',
            width: 120,
          }, //商品编码
          {
            title: '商品描述',
            field: 'productDesc',
            width: 120,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
              events: { change: this.productDescChange },
            },
          }, //商品描述
          {
            title: '规格型号',
            field: 'productSpecificationModel',
            width: 120,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          }, //规格型号
          {
            field: 'expenseItem',
            title: '费用项目',
            width: 120,
            editRender: {
              name: 'ElSelect',
              options: this.expenseItemList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            title: '结算数量',
            field: 'settlementQuantity',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceLastZeroStr(
                      this.$baseRequest.formatTableColumn(row.settlementQuantity, 3)
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementQuantity']}
                    placeholder={this.$t(
                      'financeSalesInvoiceDetail.placeholder.settlementQuantity'
                    )}
                    clearable={true}
                    precision={this.$globalVar.qPoint}
                    max={9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'settlementQuantity')}
                  ></input-number-ad>,
                ];
              },
            },
          }, //结算数量

          {
            //项目
            field: 'projectInitiationNo',
            title: '项目编号',
            width: 120,
            /* ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.projectInitiationNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="projectInitiation"
                      isMultiple={true}
                      currentValue={row['projectInitiationNo']}
                      checkRowKeys={[row['projectInitiationNo']]}
                      extraData={{
                        applyCompanyNo: this.invoiceInfo?.invoiceCompanyCode,
                        applyDepartmentNo: this.invoiceInfo?.invoiceDepartmentNo,
                        customerNo: this.invoiceInfo?.partnerCode,
                        projectInitiationStatusList: ['PIS04', 'PIS05'],
                      }}
                      onInput={(val) => this.updateCol(row, val, 'projectInitiationNo')}
                    ></search-table>,
                  ];
                },
              },
            }, */
          },
          {
            title: this.invoiceInfo.businessType == '02' ? '本次结算数量' : '本次开票数量',
            field: 'invoiceQuantity',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceLastZeroStr(
                      this.$baseRequest.formatTableColumn(
                        row.invoiceQuantity,
                        this.isWuMaoAccount ? 8 : this.$globalVar.qPoint
                      )
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['invoiceQuantity']}
                    placeholder={this.$t('financeSalesInvoiceDetail.placeholder.invoiceQuantity')}
                    clearable={true}
                    precision={this.isWuMaoAccount ? 8 : this.$globalVar.qPoint}
                    max={this.invoiceInfo.invoiceType == 'invoice' ? 9999999999 : 0}
                    min={this.invoiceInfo.invoiceType == 'invoice' ? 0 : -9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'invoiceQuantity')}
                  ></input-number-ad>,
                ];
              },
            },
          }, //本次开票数量
          {
            title: this.$t('financeSalesInvoiceDetail.column.invoiceUnit'),
            field: 'invoiceUnit',
            width: 120,
            editRender: {
              name: 'ElSelect',
              options: this.dictMap.unitOptions,
              props: { clearable: true, filterable: true },
            },
          }, //单位
          {
            title: '含税单价',
            field: 'invoiceUnitPrice',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceLastZeroStr(
                      this.$baseRequest.formatTableColumn(row.invoiceUnitPrice, 8)
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <span>
                    {this.replaceLastZeroStr(
                      this.$baseRequest.formatTableColumn(row.invoiceUnitPrice, 8)
                    )}
                  </span>,
                ];
              },
            },
          }, //含税单价
          {
            title: '含税总金额',
            field: 'invoiceAmount',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.invoiceAmount, this.$globalVar.pPoint)
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['invoiceAmount']}
                    placeholder={this.$t('financeSalesInvoiceDetail.placeholder.invoiceAmount')}
                    clearable={true}
                    precision={this.$globalVar.aPoint}
                    max={this.invoiceInfo.invoiceType == 'invoice' ? 9999999999 : 0}
                    min={this.invoiceInfo.invoiceType == 'invoice' ? 0 : -9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'invoiceAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          }, //含税总金额
          {
            title: '结算已开票金额',
            field: 'settlementApplyInvoiceAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.replaceZeroStr(row.settlementApplyInvoiceAmount)}</span>];
              },
            },
            /* editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.settlementApplyInvoiceAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementApplyInvoiceAmount']}
                    placeholder={this.$t('financeSalesInvoiceDetail.placeholder.settlementApplyInvoiceAmount')}
                    clearable={true}
                    precision={this.$globalVar.aPoint}
                    max={this.invoiceInfo.invoiceType == 'invoice' ? 9999999999 : 0}
                    min={this.invoiceInfo.invoiceType == 'invoice' ? 0 : -9999999999}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'settlementApplyInvoiceAmount')}
                  ></input-number-ad>,
                ];
              },
            }, */
          }, //结算已开票金额
          {
            title: this.$t('financeSalesInvoiceDetail.column.excludedTaxAmount'),
            field: 'excludedTaxAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.excludedTaxAmount)
                    )}
                  </span>,
                ];
              },
            },
          }, //不含税金额
          {
            title: this.$t('financeSalesInvoiceDetail.column.taxAmount'),
            field: 'taxAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(this.$baseRequest.formatTableColumn(row.taxAmount))}
                  </span>,
                ];
              },
            },
          }, //税额
          // {
          //   title: this.$t('financeSalesInvoiceDetail.column.taxCode'),
          //   field: 'taxCode',
          //   width: 280,
          //   editRender: {
          //     name: 'ElSelect',
          //     options: this.taxRateList,
          //     props: { clearable: true, filterable: true },
          //     events: { change: (obj) => this.updateEvent(obj, 'taxCode') },
          //   },
          // }, //税码
          {
            title: this.$t('financeSalesInvoiceDetail.column.taxRate'),
            field: 'taxRate',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.taxRate, this.$globalVar.tPoint)}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['taxRate']}
                    placeholder={this.$t('financeSalesInvoiceDetail.placeholder.taxRate')}
                    clearable={true}
                    precision={this.$globalVar.tPoint}
                    max={1}
                    min={0}
                    maxLength={10}
                    onInput={(val) => this.updateCol(row, val, 'taxRate')}
                  ></input-number-ad>,
                ];
              },
            },
          }, //税率
          {
            title: this.$t('financeSalesInvoiceDetail.column.invoiceAccountedAmount'),
            field: 'invoiceAccountedAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.invoiceAccountedAmount,
                      this.$globalVar.tPoint
                    )}
                  </span>,
                ];
              },
            },
          }, //本币含税金额
          {
            title: this.$t('financeSalesInvoiceDetail.column.excludedTaxAccountedAmount'),
            field: 'excludedTaxAccountedAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.excludedTaxAccountedAmount)
                    )}
                  </span>,
                ];
              },
            },
          }, //本币不含税金额
          {
            title: this.$t('financeSalesInvoiceDetail.column.taxAccountedAmount'),
            field: 'taxAccountedAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.taxAccountedAmount)
                    )}
                  </span>,
                ];
              },
            },
          }, //本币税额
          {
            title: '币种',
            field: 'currency',
            width: 120,
            // editRender: { name: 'ElInput', props: { clearable: true } },
          }, //币种
          {
            title: this.$t('financeSalesInvoiceDetail.column.exchangeRate'),
            field: 'exchangeRate',
            width: 120,
          }, //汇率
          {
            title: this.$t('financeSalesInvoiceDetail.column.mark'),
            field: 'mark',
            width: 500,
            editRender: { name: 'ElInput', props: { clearable: true } },
          }, //备注
        ];
      },
    },
    mounted() {
      //税率
      this.$baseRequest.getTaxRate().then((res) => {
        this.taxRateList = res.filter((it) => it.taxType == 'OT');
      });
    },
    watch: {
      //监听发票信息变化 更新表格币种汇率等
      invoiceInfo: {
        handler(newV) {
          console.log('表单变化', newV.currency, newV);
          let fulldata = this.$refs.ruleTable.getTableData().fullData;
          fulldata = fulldata.map((item) => {
            item.currency = newV.currency;
            if (!['02', '03', '04', '05'].includes(newV.businessType)) {
              item.taxRate =
                item.detailExtendList && item.detailExtendList.length
                  ? item.detailExtendList[0].taxRate ?? 0
                  : 0;
            }
            // 本币计算
            if (newV.exchangeRate && newV.exchangeRate != item.exchangeRate) {
              item.exchangeRate = newV.exchangeRate;

              item.taxAccountedAmount = this.$cal.calCommon(
                item.taxAmount,
                item.exchangeRate,
                '*',
                'amount'
              );
              item.invoiceAccountedAmount = this.$cal.calCommon(
                item.invoiceAmount,
                item.exchangeRate,
                '*',
                'amount'
              );
              item.excludedTaxAccountedAmount = this.$cal.calCommon(
                item.invoiceAccountedAmount,
                item.taxAccountedAmount,
                '-',
                'amount'
              );
            }
            return item;
          });
          this.$refs.ruleTable.updateData(fulldata);
        },
        deep: true,
      },
      'invoiceInfo.businessType': {
        handler(newValue, oldValue) {
          console.log(newValue, '切换变化', oldValue);
          // expenseItemList
          if (newValue) {
            const dictMap = {
              '01': this.dictListMap.IncomeExpenseItemsTrade || [], // 贸易
              '02': this.dictListMap.IncomeExpenseItemsTransportation || [], // 多式联运
              '03': this.dictListMap.IncomeExpenseItemsWarehousing || [], // 园区仓储
              '04': this.dictListMap.IncomeExpenseItemsParkProperties || [], // 园区物业
              '05': this.dictListMap.IncomeExpenseItemsSupervisionForm || [], // 监管单
              '06': this.dictListMap.IncomeExpenseItemsTrade || [], // 城矿
            };
            this.expenseItemList = dictMap[newValue];
            if (newValue != oldValue) {
              console.log('进来了');
              // 刷新表格
              // let fullData = this.$refs.ruleTable.getTableData().fullData.map((item) => {
              //   return {
              //     ...item,
              //     expenseItem: '',
              //   };
              // });
              // this.tableData = fullData;
              // this.$refs.ruleTable.updateData(fullData);
            }
          }
        },
        immediate: true,
        deep: true,
      },
      canEdit: {
        handler(val) {
          this.$emit('isTableDataHandler', !val);
        },
        deep: true,
      },
    },
    methods: {
      //
      importRowDetail() {
        let fullData = this.getTableData().map((item) => item.receivableSettlementLineId);
        this.$refs.siruiUpload.openDialog(true, 'KPMB', fullData, this.invoiceInfo.exchangeRate);
      },
      importSuccess(importMap) {
        let fullData = this.getTableData();
        fullData.forEach((item) => {
          for (const key in importMap) {
            if (`${item.receivableSettlementNo}-${item.receivableSettlementLineId}` == key) {
              console.log('item.detailExtendList != null', item.detailExtendList);
              if (item.detailExtendList != null) {
                importMap[key].forEach((val) => item.detailExtendList.push(val));
              } else {
                item.detailExtendList = importMap[key];
              }
            }
          }
        });
        this.$emit('changeRowDetail');
      },
      getTableData() {
        console.log(this.$refs.ruleTable.getTableData().fullData, '表格数据');
        return this.$refs.ruleTable.getTableData().fullData;
      },
      // 选择行的时候
      handleSelectionChange(row) {
        console.log(row.selection);
        this.$emit('selectionChanged', row.selection);
      },
      dblclickEvent(val) {
        console.log('双击的行', val);
        let row = val.row;
        this.$emit('changeCurrentRowInfo', row);
      },
      async handleSettleBatch() {
        this.isVisibleSettlement = true;
        let flag = await this.validateInvoice();
        let ids = this.getTableData()?.map((item) => item.receivableSettlementLineId?.toString());

        if (flag) {
          this.$refs.settlementBatch.open(
            this.invoiceInfo,
            this.currentSettlementBusinessType,
            ids
          );
        }
      }, // 币种格式转换
      fotmatCurrency({ cellValue }) {
        console.log('currencyValue', cellValue);
        if (cellValue) return this.currencyList.find((it) => it.value == cellValue).label;
        return '';
      },
      productDescChange() {},
      updateSettle(v, row = {}) {
        let obj = v[0];
        console.log(obj, '更新数据', obj.originalTotalAmount, this.invoiceInfo.businessType, row);
        let currencyCode =
          obj.currencyCode || this.invoiceInfo.currencyCode || this.invoiceInfo.currencycode;
        console.log('currencyCode', currencyCode);
        row = {
          ...row,
          receivableSettlementNo: obj.receivableSettlementNo,
          contractNo: obj.contractNo,
          productNo: obj.productCode,
          productDesc: obj.productName,
          orderCode: obj.orderCode,
          detailExtendList: [],
          id: obj.id,
          settlementQuantity: obj.settlementQuantity,
          projectInitiationNo: obj.projectInitiationNo,
          invoiceUnit: obj.payunitCode,
          receivableSettlementLineId: obj.id,
          outboundNo: obj.businessDocNo,
          currency: obj.currencyCode,
          currencycode: this.invoiceInfo.currencycode || this.invoiceInfo.currencyCode,
          currencyCode: currencyCode,
          currencyName: this.invoiceInfo.currencyName || obj.currencyName,
          exchangeRate: this.invoiceInfo.exchangeRate,
          invoiceAccountedAmount:
            this.currentSettlementBusinessType == 1 ? obj.originalAmount : obj.originalTotalAmount,
          invoiceAmount:
            this.currentSettlementBusinessType == 1 ? obj.originalAmount : obj.originalTotalAmount,
          invoiceQuantity:
            this.invoiceInfo.businessType != '01' || this.invoiceInfo.businessType != '06'
              ? this.invoiceInfo.businessType == '02'
                ? obj.settlementQuantity
                : 1
              : '',
          invoiceUnitPrice:
            this.currentSettlementBusinessType == 1
              ? Number(obj.originalAmount) / Number(obj.settlementQuantity)
              : obj.originalTotalAmount,
        };
        if (this.invoiceInfo.invoiceType == 'invoice') {
          row.invoiceQuantity =
            obj.settlementQuantity ||
            (this.invoiceInfo.businessType != '01' || this.invoiceInfo.businessType != '06'
              ? this.invoiceInfo.businessType == '02'
                ? obj.settlementQuantity
                : 1
              : '');
          // row.invoiceUnitPrice = obj.originalPrice || 0; // 含税单价
          row.settlementApplyInvoiceAmount = obj.applyInvoiceAmount;
          // TODO 先注释
          // row.invoiceAmount = this.$cal.calCommon(
          //   obj.originalAmount,
          //   obj.applyInvoiceAmount,
          //   '-',
          //   'amount'
          // );
          // row.invoiceAccountedAmount = this.$cal.calCommon(
          //   this.$cal.calCommon(obj.originalAmount, obj.applyInvoiceAmount, '-', 'amount'),
          //   this.invoiceInfo.exchangeRate,
          //   '*',
          //   'amount'
          // );
        }
        console.log(row, '=====插入');
        if (row?._XID) {
          let fulldata = this.$refs.ruleTable.getTableData().fullData;
          let index = fulldata.findIndex((item) => item._XID == row._XID);
          fulldata[index] = row;
          console.log(row, '1111');
          // this.$refs['ruleTable'].loadData(fulldata);
        } else {
          this.$refs['ruleTable'].insertAt(row, null).then(() => {});
        }
        this.$refs['ruleTable'].updateFooter();
        this.setSettlementNo();
        this.$emit(
          'clearStatementDetailTableHandler',
          this.$refs.ruleTable.getTableData().fullData
        );
        this.isVisibleSettlement = false;
      },
      // 将结算单数据提交到父组件
      setSettlementNo() {
        console.log('关联结算单');
        let data = [];
        this.$refs.ruleTable.getTableData().fullData.map((item) => {
          data.push(item.receivableSettlementNo);
        });
        // console.log("data",data)
        this.$emit('setSettlement', data);
      },
      async handleInsert() {
        // console.log("新增行",this.invoiceInfo.currencycode,this.invoiceInfo.currencyName,this.invoiceInfo.currency)
        let flag = await this.validateInvoice();
        if (!flag) return;
        // const userInfo = this.userInfo;
        let params = {
          currency: this.invoiceInfo.currency,
          currencycode: this.invoiceInfo.currency,
          currencyName:
            this.invoiceInfo.currencyName ||
            this.currencyList.find((it) => it.value == this.invoiceInfo.currency).label,
          exchangeRate: this.invoiceInfo.exchangeRate,
        };
        params = this.$baseRequest.assignObj(params);
        this.$refs.ruleTable
          .insertAt(params, -1)
          .then(({ row }) => this.$refs.ruleTable.setActiveRow(row));
      },
      activeRowMethod() {
        if (['物贸', '多式联运', '城矿'].includes(this.userInfo.businessGroup)) {
          return false;
        }
        //禁用编辑
        return this.canEdit;
      },
      // editRender更新字段
      updateEvent(obj) {
        console.log(obj);
        let row = obj.row;
        // row['taxRate'] = this.taxRateList.find((it) => it.taxCode == row.taxCode).taxRate;
        // 税额 = 含税总额*税率(错的)  = 含税金额/(1+税率）*税率
        let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
        let step2 = this.$cal.calCommon(row['invoiceAmount'], step1, '/');
        row['taxAmount'] = this.$cal.calCommon(step2, row['taxRate'], '*', 'amount');
        // 不含税总额 = 含税总额-税额
        row['excludedTaxAmount'] = this.$cal.calCommon(row['invoiceAmount'], row['taxAmount'], '-');

        // 本币计算
        row.taxAccountedAmount = this.$cal.calCommon(
          row.taxAmount,
          row.exchangeRate,
          '*',
          'amount'
        );
        row.invoiceAccountedAmount = this.$cal.calCommon(
          row.invoiceAmount,
          row.exchangeRate,
          '*',
          'amount'
        );
        row.excludedTaxAccountedAmount = this.$cal.calCommon(
          row.invoiceAccountedAmount,
          row.taxAccountedAmount,
          '-',
          'amount'
        );
        this.$emit('calTotal', true);
      },
      //JSX更新字段
      updateCol(row, val, type) {
        console.log(row, val, type, '更新行信息');
        row[type] = val;
        if (type == 'contractNo') {
          row[type] = val && val[0] ? val[0].contractNo : null;
          return;
        } else if (type == 'taxRate') {
          let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
          // 不含税 = 含税/（1+税率）
          row['excludedTaxAmount'] = this.$cal.calCommon(
            row['invoiceAmount'],
            step1,
            '/',
            'amount'
          );
          row['taxAmount'] = this.$cal.calCommon(
            row['invoiceAmount'],
            row['excludedTaxAmount'],
            '-',
            'amount'
          );
        } else if (type == 'invoiceQuantity') {
          // 修改总额跟数量 计算单价
          // row['invoiceUnitPrice'] = this.$cal.calCommon(
          //   row['invoiceAmount'],
          //   row['invoiceQuantity'],
          //   '/',
          //   'amount'
          // );

          row['invoiceUnitPrice'] =
            row['invoiceQuantity'] == 0
              ? 0
              : (row['invoiceAmount'] / row['invoiceQuantity']).toFixed(6);
          console.log('修改数量', row['invoiceUnitPrice']);
        } else if (type == 'invoiceAmount') {
          let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
          // 不含税 = 含税/（1+税率）
          row['excludedTaxAmount'] = this.$cal.calCommon(
            row['invoiceAmount'],
            step1,
            '/',
            'amount'
          );
          row['taxAmount'] = this.$cal.calCommon(
            row['invoiceAmount'],
            row['excludedTaxAmount'],
            '-',
            'amount'
          );
          // 含税单价 = 总额/本次开票数量
          // row['invoiceUnitPrice'] = this.$cal.calCommon(
          //   row['invoiceAmount'],
          //   row['invoiceQuantity'],
          //   '/',
          //   'price'
          // );
          row['invoiceUnitPrice'] = !row['invoiceQuantity']
            ? 0
            : (row['invoiceAmount'] / row['invoiceQuantity']).toFixed(6);
          console.log(
            row['invoiceQuantity'],
            row['invoiceAmount'],
            '===修改金额=>>>',
            row['invoiceUnitPrice']
          );
        }
        // else if (type == 'invoiceQuantity') {
        //   // 含税单价 = 总额/本次开票数量
        //   row['invoiceUnitPrice'] = !row['invoiceQuantity']
        //     ? 0
        //     : this.$cal.calCommon(row['invoiceAmount'], row['invoiceQuantity'], '/', 'price');
        //   console.log(row['invoiceUnitPrice'], '1111');
        // }
        else if (type == 'receivableSettlementNo') {
          let obj = val[0];
          row['receivableSettlementNo'] = obj.receivableSettlementNo;
          console.log(row['receivableSettlementNo'], '结算单编号');
          row['productNo'] = obj.productCode;
          row['productDesc'] = obj.productName;
          row['projectInitiationNo'] = obj.projectInitiationNo;
          row['settlementQuantity'] = obj.settlementQuantity;
          row['outboundNo'] = obj.receivableSettlementNo;
          row['receivableSettlementLineId'] = obj.receivableSettlementId;
          row['contractNo'] = obj.contractNo;
          row['currencyName'] = obj.currencyName;
          row['currency'] = obj.currencyCode;
          row['currencyCode'] = obj.currencyCode;
          this.updateSettle(val, row);
          return;
        } else if (type == 'projectInitiationNo') {
          let obj = val[0];
          row['projectInitiationNo'] = obj.projectInitiationNo;
          return;
        }
        // 本币计算
        row.taxAccountedAmount = this.$cal.calCommon(
          row.taxAmount,
          row.exchangeRate,
          '*',
          'amount'
        );
        row.invoiceAccountedAmount = this.$cal.calCommon(
          row.invoiceAmount,
          row.exchangeRate,
          '*',
          'amount'
        );
        row.excludedTaxAccountedAmount = this.$cal.calCommon(
          row.invoiceAccountedAmount,
          row.taxAccountedAmount,
          '-',
          'amount'
        );
        console.log(row['taxRate']);
        this.$emit('calTotal', true);
      },
      // 计算合计金额
      calTotal() {
        let fulldata = this.$refs.ruleTable.getTableData().fullData;
        console.log(fulldata);
        let excludedTaxAccountedAmount = 0;
        let total = {
          invoiceAmount: 0,
          invoiceAccountedAmount: 0,
          excludedTaxAmount: 0,
          excludedTaxAccountedAmount: 0,
          taxAmount: 0,
          taxAccountedAmount: 0,
          ladingDifferenceAmount: 0,
        };
        fulldata.map((item) => {
          total.invoiceAmount = this.$cal.calCommon(item.invoiceAmount, total.invoiceAmount, '+');
          total.excludedTaxAmount = this.$cal.calCommon(
            item.excludedTaxAmount,
            total.excludedTaxAmount,
            '+'
          );
          total.taxAmount = this.$cal.calCommon(item.taxAmount, total.taxAmount, '+');
          total.invoiceAccountedAmount = this.$cal.calCommon(
            item.invoiceAccountedAmount,
            total.invoiceAccountedAmount,
            '+'
          );
          // total.excludedTaxAccountedAmount = this.$cal.calCommon(
          //   item.excludedTaxAccountedAmount,
          //   total.excludedTaxAccountedAmount,
          //   '+'
          // );
          excludedTaxAccountedAmount += item.excludedTaxAccountedAmount;
          total.excludedTaxAccountedAmount = this.replaceZeroStr(
            excludedTaxAccountedAmount.toFixed(2)
          );
          total.taxAccountedAmount = this.$cal.calCommon(
            item.taxAccountedAmount,
            total.taxAccountedAmount,
            '+'
          );
          total.ladingDifferenceAmount = this.$cal.calCommon(
            item.ladingDifferenceAmount,
            total.ladingDifferenceAmount,
            '+'
          );
        });
        return total;
      },
      editClosedEvent(row) {
        console.log(row);
      },
      updateRow(row, obj) {
        row.invoiceAmount = obj.invoiceAmount;
        row.excludedTaxAmount = obj.excludedTaxAmount;
        row.taxAmount = obj.taxAmount;
        row.invoiceAccountedAmount = obj.invoiceAccountedAmount;
        row.excludedTaxAccountedAmount = obj.excludedTaxAccountedAmount;
        row.taxAccountedAmount = obj.taxAccountedAmount;
        row.ladingDifferenceAmount = obj.ladingDifferenceAmount;
        row.recoverableTaxAmount = obj.recoverableTaxAmount;
      },
      getValues() {
        const allData = this.$refs['ruleTable'].getTableData();
        const tableData = allData.tableData;
        return tableData.map((item, index) => {
          const result = Object.assign({}, item, {
            invoiceDetailCode: item.invoiceDetailCode || index + 1,
          });
          return result;
        });
      },
      checkAmount() {
        return true; //暂时不校验金额
        // const tableData = row ? [row] : this.$refs['ruleTable'].getTableData().fullData;
        // const flag = tableData.some((row) => {
        //   // 总金额≤提单金额-已开票金额，如果校验不通过则提示，开票金额超过提单金额，请修改
        //   if (row.invoiceQuantity && row.invoiceUnitPrice && row.ladingNo && row.ladingDetailNo) {
        //     const invoiceAmount = this.$cal.calCommon(
        //       row.invoiceQuantity,
        //       row.invoiceUnitPrice,
        //       '*',
        //       'amount'
        //     ); //
        //     const checkAmount = this.$cal.calCommon(row.ladingAmount, row.invoicedAmount, '-'); //
        //     if (invoiceAmount > checkAmount) {
        //       return true;
        //     }
        //   }
        // });
        // if (flag) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t('saleInvoice.overAmount'),
        //     type: 'error',
        //   });
        // }
        // return flag;
      },
      handleSubmit() {
        return new Promise((resolve) => {
          this.$refs.ruleTable.validate((valid) => {
            const list = this.getValues();
            if (list.length === 0) {
              this.$message({
                showClose: true,
                message: this.$t('saleInvoice.noListTip'),
                type: 'error',
              });
              return false;
            }
            if (valid && list.length > 0 && !this.checkAmount()) resolve();
          });
        });
      },
      handleDelete() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs['ruleTable'].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
            this.$refs['ruleTable'].reloadData(this.$refs['ruleTable'].getTableData().fullData);

            this.$emit('calTotal', true);
            this.setSettlementNo();
            this.$emit('deleteRowInfoHandler', true);
            // console.log("aa",this.$refs['ruleTable'].getTableData().fullData)
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancle'),
            });
          });
      },
      // 生成校验规则
      getRules() {
        const emptyTip = this.$t('contractAgency.productTab.emptyTip');
        const rules = {};
        this.columnsList.forEach((item) => {
          const required = typeof item.required === 'function' ? item.required() : item.required;
          if (required) {
            const title = this.$t('saleInvoice.' + (item.otherKey || item.field));
            const message = title + emptyTip;
            rules[item.field] = [{ required: true, message: message }];
          }
        });
        return rules;
      },
      // 通用底部合计总数 - footerTotalCols定义在各个具体文件中，示例如下
      // footerTotalCols:{amount:['contractTotalAmount'],quantity:['productQuantity']}, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点

      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = XEUtils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                } else if (key == 'invoiceQuantity') {
                  point = 8;
                }
                total = this.replaceZeroStr(XEUtils.toNumber(total).toFixed(point));
                return total;
              }
            }
          }),
        ];
      },
    },
  };
</script>
<style lang="scss" scoped>
  .price-col {
    line-height: 18px;
  }
</style>
